import ServicesGrid from "@/components/ServicesGrid";
import ProcessSection from "@/components/ProcessSection";
import CTASection from "@/components/CTASection";
import PageHeader from "@/components/PageHeader";

export default function ServicesPage() {
  return (
    <>
      <PageHeader
        eyebrow="/ Services"
        title={<>Nine practices. <span className="text-gradient">One accountable team.</span></>}
        copy="DevOps, DevSecOps, cloud migration, IaC, observability and FinOps — delivered by senior engineers who own the outcome in production."
      />
      <ServicesGrid />
      <ProcessSection />
      <CTASection />
    </>
  );
}
